import { ReceiptContainer } from 'modules/PaymentManagement';
import { RefundsContainer } from 'modules/Refunds';
import { useParams } from 'react-router-dom';

type Props = {}

const Receipt = (props: Props) => {
    const { userType } = useParams();
    return (
        <ReceiptContainer />
    )
}

export default Receipt  